import { artworkContract } from "./artwork.mjs";
import { attributionContract } from "./attribution.mjs";
import { bannerContract } from "./banner.mjs";
import { campaignAdsContract } from "./campaignAds.mjs";
import { claimContract } from "./claim.mjs";
import { contentSafetyPreferenceContract } from "./contentSafetyPreference.mjs";
import { contestContract } from "./contest.mjs";
import { creditExchangeContract } from "./creditExchange.mjs";
import { decorationContract } from "./decoration.mjs";
import { footprintContract } from "./footprint.mjs";
import { generationModelContract } from "./generationModel.mjs";
import { i18nContract } from "./i18n.mjs";
import { imageFilterContract } from "./imageFilter.mjs";
import { authContract } from "./auth/index.mjs";
import { oauth2ClientContract } from "./auth/oauth2Client.mjs";
import { contestV2Contract } from "./contestV2/index.mjs";
import { eventPassContract } from "./event/eventPass.mjs";
import { springPromotionEvent2026Contract } from "./event/springPromotionEvent2026.mjs";
import { surprisePackContract } from "./event/surprisePack.mjs";
import { extraPackageBoostContract } from "./extraPackageBoost/user.mjs";
import { imageContract } from "./image/contract.mjs";
import { taskContract } from "./task/contract.mjs";
import { internalImageContract } from "./internal/image.mjs";
import { kotoneCreditContract } from "./internal/kotoneCredit.mjs";
import { kotoneOrderContract } from "./internal/kotoneOrder.mjs";
import { internalReferralContract } from "./internal/referral.mjs";
import { internalTaskContract } from "./internal/task.mjs";
import { internalTaskEditContract } from "./internal/taskEdit.mjs";
import { internalUserExternalProfilesContract } from "./internal/userExternalProfiles.mjs";
import { kaisuukenContract } from "./kaisuuken.mjs";
import { lotteryContract } from "./lottery.mjs";
import { mediaContract } from "./media.mjs";
import { modelExperimentSessionContract } from "./modelExperimentSession.mjs";
import { uaNewbiePackContract } from "./newbiePack.mjs";
import { notificationPreferenceContract } from "./notificationPreference.mjs";
import { oauth2Contract } from "./oauth2/index.mjs";
import { orderContract } from "./order/index.mjs";
import { paymentContract } from "./payment.mjs";
import { extraPackageContract } from "./payment/extraPackage/index.mjs";
import { questV2Contract } from "./questV2.mjs";
import { referenceVideoContract } from "./referenceVideo.mjs";
import { referralCampaignContract } from "./referralCampaign.mjs";
import { ssrContract } from "./ssr.mjs";
import { styleKeyRefContract } from "./styleKeyRef.mjs";
import { tackContract } from "./tack.mjs";
import { tagContract } from "./tag.mjs";
import { testOpsContract } from "./testOps.mjs";
import { tierRewardContract } from "./tierReward.mjs";
import { userArtworkContract } from "./userArtwork.mjs";
import { userDecorationRelationContract } from "./userDecorationRelation.mjs";
import { userOrderEmailContract } from "./userOrderEmail.mjs";
//#region src/api/orpc/index.ts
const baseContract = {
	artwork: artworkContract,
	attribution: attributionContract,
	auth: authContract,
	banner: bannerContract,
	campaignAds: campaignAdsContract,
	claim: claimContract,
	contentSafetyPreference: contentSafetyPreferenceContract,
	contest: contestContract,
	contestV2: contestV2Contract,
	creditExchange: creditExchangeContract,
	decoration: decorationContract,
	eventPass: eventPassContract,
	extraPackageBoost: extraPackageBoostContract,
	footprint: footprintContract,
	generationModel: generationModelContract,
	i18n: i18nContract,
	image: imageContract,
	imageFilter: imageFilterContract,
	internalImage: internalImageContract,
	kotoneOrder: kotoneOrderContract,
	internalReferral: internalReferralContract,
	internalTask: internalTaskContract,
	internalTaskEdit: internalTaskEditContract,
	internalUserExternalProfiles: internalUserExternalProfilesContract,
	kaisuuken: kaisuukenContract,
	kotoneCredit: kotoneCreditContract,
	lottery: lotteryContract,
	media: mediaContract,
	modelExperimentSession: modelExperimentSessionContract,
	notificationPreference: notificationPreferenceContract,
	extraPackage: extraPackageContract,
	oauth2: oauth2Contract,
	oauth2Client: oauth2ClientContract,
	order: orderContract,
	payment: paymentContract,
	questV2: questV2Contract,
	referenceVideo: referenceVideoContract,
	referralCampaign: referralCampaignContract,
	springPromotionEvent2026: springPromotionEvent2026Contract,
	surprisePack: surprisePackContract,
	ssr: ssrContract,
	styleKeyRef: styleKeyRefContract,
	tack: tackContract,
	tag: tagContract,
	task: taskContract,
	testOps: testOpsContract,
	tierReward: tierRewardContract,
	uaNewbiePack: uaNewbiePackContract,
	user: userArtworkContract,
	userDecorationRelation: userDecorationRelationContract,
	userOrderEmail: userOrderEmailContract
};
//#endregion
export { baseContract };
